import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ButtonGroup from 'components/shared/button-group/button-group';
import CoachNoEventsMessage from './coach-no-events-message';
import PublicNoEventsMessage from './public-no-events-message';
import ScheduleEvent from './schedule-event';
import TabWrapper from 'components/shared/profile-tabs/tab-wrapper';
import _ from 'underscore';
import LocalizedMessage from 'common/localized-message';
import {
  changeScheduleSeason,
  changeScheduleView,
} from 'common/actions';
import { FormModifier, SingleSelect } from 'components/shared/uniform';

import './schedule-tab.scss';

class ScheduleTab extends React.Component {
  static propTypes = {
    dispatch: React.PropTypes.func,
    forcePublicView: React.PropTypes.bool,
    httpsAllowed: React.PropTypes.bool,
    team: React.PropTypes.shape({
      allSeasons: React.PropTypes.arrayOf(React.PropTypes.shape({
        id: React.PropTypes.string.isRequired,
        hasDetails: React.PropTypes.bool,
        year: React.PropTypes.number.isRequired,
        events: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
      })),
      manageScheduleUrl: React.PropTypes.string,
      profileUrlBase: React.PropTypes.string.isRequired,
      selectedSeasonId: React.PropTypes.string,
      schoolName: React.PropTypes.string.isRequired,
      teamId: React.PropTypes.string,
      teamName: React.PropTypes.string.isRequired,
    }),
    seoFriendlyName: React.PropTypes.string.isRequired,
    user: React.PropTypes.shape({
      isPrivilegedUser: React.PropTypes.bool,
      lastName: React.PropTypes.string,
      userId: React.PropTypes.string,
    }),
    convertTimesToLocal: React.PropTypes.bool,
    isMobile: React.PropTypes.bool.isRequired,
    schedule: React.PropTypes.shape({
      view: React.PropTypes.string,
    }),
    onChangeTab: React.PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.changeSeason = this.changeSeason.bind(this);
    this.onChangeView = this.onChangeView.bind(this);
  }

  componentDidMount() {
    const season = _.findWhere(this.props.team.allSeasons, { isSelected: true });

    if (season && !season.hasDetails) {
      this.props.dispatch(changeScheduleSeason(season.id));
    }
  }

  changeSeason(season) {
    this.props.dispatch(changeScheduleSeason(season.value));
  }

  onChangeView(option) {
    this.props.dispatch(changeScheduleView(option));
  }

  getGames(season) {
    const showTraining = this.props.schedule.view === 'training';
    const filteredEvents = season.events.filter(event => {
      return showTraining ? (event.isPractice || event.isScrimmage) :
        (!event.isPractice && !event.isScrimmage);
    });
    const sortedEvents = _.sortBy(filteredEvents, e => moment(e.utcTime).unix());

    const games = sortedEvents.map(event => {
      return (
        <ScheduleEvent
          key={event.gameId}
          isPrivilegedUser={this.props.user.isPrivilegedUser}
          forcePublicView={this.props.forcePublicView}
          manageScheduleUrl={this.props.team.manageScheduleUrl}
          seasonId={season.id}
          teamProfileUrlBase={this.props.team.profileUrlBase}
          teamId={this.props.team.teamId}
          convertTimesToLocal={this.props.convertTimesToLocal}
          {...event}/>
      );
    });

    if (!games.length) {
      if (this.props.user.isPrivilegedUser && !this.props.forcePublicView) {
        return (
          <CoachNoEventsMessage
            manageScheduleUrl={this.props.team.manageScheduleUrl}
            seasonId={season.id}
            userLastName={this.props.user.lastName}/>
        );
      }

      return (
        <PublicNoEventsMessage
          onChangeTab={this.props.onChangeTab}
          isTraining={showTraining}
          {...this.props.team}
        />
      );
    }

    return games;
  }

  getSeasons() {
    const sortedSeasons = _.sortBy(this.props.team.allSeasons, season => {
      return season.year;
    }).reverse();

    return sortedSeasons.map(season => {
      return {
        label: `${season.year} - ${season.year + 1}`,
        value: season.id,
      };
    });
  }

  render() {
    const view = this.props.schedule.view;
    const season = _.findWhere(this.props.team.allSeasons, { isSelected: true });
    const showAddButton = this.props.user.isPrivilegedUser && !this.props.forcePublicView;

    return (
      <TabWrapper>
        <main className="tab-panel schedule-tab">
          <div className="schedule-controls">
            <div className="view-toggle">
              <ButtonGroup buttons={[
                {
                  label: 'Games',
                  value: 'games',
                  isSelected: view === 'games',
                },
                {
                  label: 'Training',
                  value: 'training',
                  isSelected: view === 'training',
                },
              ]} onButtonPressed={this.onChangeView}/>
            </div>

            <div className="season-switcher">
              <FormModifier size="small">
                <SingleSelect
                  defaultValue={season.id}
                  options={this.getSeasons()}
                  onChange={this.changeSeason}
                  hideDismiss
                />
              </FormModifier>
            </div>

            {/* Don't show the manage schedule button when showing the coach blank state */ }
            {showAddButton ?
              <div className="add-event-button">
                <a href={this.props.team.manageScheduleUrl + '/' + season.id}
                  className="uni-btn--secondary--minimal uni-btn--small">
                  <LocalizedMessage id="profiles.team.update_schedule_label"/>
                </a>
              </div>
              : null
            }
          </div>
          <ul className="compact-margin">
            {this.getGames(season)}
          </ul>
        </main>
      </TabWrapper>
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(ScheduleTab);
